const frBilling = {
    // Pricing page, worded as the plan sheet it comes from
    pricingEyebrow: "SCORE VISION",
    pricingTitle: "Choisissez votre formule",
    pricingSubtitle: "Activation immédiate dès validation du paiement",
    recommendedBadge: "RECOMMANDÉ",
    subscribe: "Souscrire",
    currentPlan: "Votre formule actuelle",
    renewPlan: "Renouveler",
    saveVsStandard: "Économisez {{percent}}% (vs Standard)",
    currencyLabel: "FCFA",

    standardDuration: "1 SEMAINE",
    premiumDuration: "2 SEMAINES",
    platinumDuration: "1 MOIS",

    standardTagline: "Pour tester la puissance des algorithmes IA",
    premiumTagline: "Le choix idéal pour les parieurs réguliers",
    platinumTagline: "L'expérience VIP illimitée et rentable",

    standardFeaturePredictions: "2 prédictions IA par jour",
    standardFeatureAccess: "1 semaine d'accès complet",
    standardFeatureSupport: "Support par email",

    premiumFeatureEverythingStandard: "Tout le plan Standard, plus :",
    premiumFeaturePredictions: "5 prédictions IA par jour",
    premiumFeatureAccess: "2 semaines d'accès complet",
    premiumFeatureHistory: "Historique complet des pronostics",
    premiumFeatureAlerts: "Alertes matchs en temps réel",

    platinumFeatureEverythingPremium: "Tout le plan Premium, plus :",
    platinumFeaturePredictions: "Pronostics IA ILLIMITÉS / jour",
    platinumFeatureVip: "1 pronostic VIP sélectionné / jour",
    platinumFeatureAccess: "1 mois d'accès (30 jours)",
    platinumFeatureStats: "Statistiques détaillées & analyses",
    platinumFeatureOdds: "Tableau comparatif des cotes",
    platinumFeatureSupport: "Support prioritaire 24/7",

    // Checkout
    /** Ikeepay collects the payment, so the methods are its own */
    paymentMethodsNotice: "Mobile money (MTN, Orange) et cartes bancaires acceptés. Le paiement s’ouvre dans une fenêtre sécurisée Ikeepay.",
    checkoutTitle: "Paiement",
    checkoutSubtitle: "Payez par mobile money ou par carte, votre formule est activée dès validation",
    orderSummary: "Récapitulatif",
    totalLabel: "Total",
    discountApplied: "Réduction parrainage de {{percent}}% appliquée",
    changePlan: "Changer de formule",
    backToPlans: "Retour aux formules",
    payNow: "Payer {{amount}}",
    paymentTerms: "En continuant, vous autorisez un paiement de {{amount}}. Le paiement est encaissé par Ikeepay, notre prestataire de paiement.",
    loadingCheckout: "Préparation du paiement",
    checkoutUnavailable: "Le paiement est momentanément indisponible, réessayez dans un instant",

    // Payment result
    paymentPendingTitle: "Paiement en cours",
    paymentPendingDescription: "Votre paiement est en cours de validation. Cette page se met à jour toute seule.",
    paymentSuccessTitle: "Paiement confirmé",
    paymentSuccessDescription: "Votre formule est active. Bonnes analyses !",
    paymentFailedTitle: "Paiement échoué",
    paymentFailedDescription: "Le paiement n'a pas abouti. Aucun montant n'a été prélevé, vous pouvez réessayer.",
    paymentCancelledTitle: "Paiement annulé",
    paymentCancelledDescription: "La demande a été annulée. Vous pouvez relancer le paiement quand vous voulez.",
    paymentTimeoutTitle: "Toujours en attente",
    paymentTimeoutDescription: "Le paiement n’a pas encore été confirmé. Vérifiez où il en est.",
    checkPaymentStatus: "Vérifier le statut",
    paymentProcessingNotice: "Un paiement mobile money peut prendre une minute",
    startAnalyzing: "Analyser un match"
}

export default frBilling
